var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect, _path30, _rect2, _path31, _path32, _path33, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect11, _path43, _path44, _rect12, _rect13, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 390,
  height: 125,
  viewBox: "0 0 390 125",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.7881 79.3633C26.2344 84.2404 -3.91628 81.2905 1.56565 102.181L386.084 107.251C398.222 102.571 375.307 60.3106 360.704 68.8253C328.915 87.3604 329.845 73.9315 287.017 45.6304C261.712 28.9078 226.694 53.1294 210.27 52.4429C180.242 51.1876 190.243 40.4027 166.807 49.1404C142.392 58.2428 124.14 66.286 101.802 68.8253C89.7858 70.1913 78.0276 87.1094 67.0134 77.0004C60.4218 70.9505 45.7777 73.0972 34.7881 79.3633Z",
  fill: "#F5F8FC",
  fillOpacity: 0.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4643 87.7507C31.3258 88.1578 -4.30677 85.8007 1.9583 103.741L389.217 106.471C380.58 89.5016 352.411 63.436 337.139 65.1307C318.868 67.1583 323.856 74.4979 278.013 57.3308C251.954 47.5726 249.642 55.4805 236.354 63.451C223.067 71.4216 183.706 84.6707 160.452 88.1578C137.198 91.6449 133.427 60.9269 113.163 63.451C102.262 64.8089 95.5193 73.7982 83.8924 66.5953C69.5434 57.706 67.1073 86.9576 43.4643 87.7507Z",
  fill: "#F5F8FC",
  fillOpacity: 0.9
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M179.289 77.019C192.254 78.591 218.739 69.3227 232.325 64.2465C253.933 54.9128 298.13 72.5978 319.737 83.8965C337.023 92.9354 366.881 99.4525 379.649 101.581C385.378 102.564 394.872 105.609 387.015 109.932C377.193 115.336 270.279 120.972 188.76 124.411C107.241 127.849 5.44788 109.932 0.537112 104.529C-4.37366 99.125 25.582 95.6863 41.7876 91.2651C57.9931 86.8439 100.226 93.7213 119.378 83.8965C138.53 74.0716 163.084 75.054 179.289 77.019Z",
  fill: "#DFE2E7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M296.468 78.8737C297.535 87.1967 306.876 88.8729 312.312 89.4882C312.978 89.4882 315.173 89.2113 318.619 88.1037C324.157 86.3236 325.08 79.9506 325.08 77.7969C325.08 72.259 321.388 70.7206 321.849 65.3365C322.008 63.4905 322.619 61.4907 321.849 57.0296C321.498 54.9901 318.773 50.8764 313.389 50.1072C305.851 49.0303 299.082 52.5685 300.467 61.6445C301.816 70.4856 295.699 72.8742 296.468 78.8737Z",
  fill: "#C2C7D0",
  stroke: "#C2C7D0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M312.31 60.4143V100.411H311.387L311.128 60.4487L311.854 57.1814L312.31 60.4143Z",
  fill: "#A3A9B9",
  stroke: "#A3A9B9"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M312.466 67.1824C313.235 66.9773 314.988 66.3825 315.85 65.6441C316.711 64.9057 317.645 64.0032 318.004 63.6443",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M315.235 65.9516C315.132 65.4389 314.989 64.321 315.235 63.9518C315.481 63.5826 315.748 63.0801 315.85 62.875",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M310.774 61.4909C310.159 61.2858 308.774 60.7833 308.159 60.4141C307.544 60.0449 306.467 59.0296 306.005 58.5681",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M308.775 60.722C308.775 60.2092 308.714 59.1221 308.467 58.876",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M312.466 79.6427C313.748 79.7966 316.465 80.0119 317.081 79.6427C317.696 79.2735 318.465 78.771 318.773 78.5659",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M315.541 79.643C315.746 79.0276 316.218 77.7662 316.464 77.6431C316.71 77.5201 317.285 77.2842 317.541 77.1816",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M310.772 73.3361C309.747 73.2336 307.511 72.9669 306.772 72.7208C306.034 72.4747 304.209 71.1825 303.388 70.5671",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M306.467 72.4127C306.416 71.8999 306.221 70.782 305.852 70.4128",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M308.619 73.1816C308.26 73.5919 307.388 74.32 306.773 74.5661",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M311.083 83.1808C309.955 83.1295 307.483 82.9654 306.007 82.7193C304.53 82.4732 302.827 81.2835 302.161 80.7195",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M308.006 82.8736C308.006 82.4121 307.852 81.5198 307.236 81.0276",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M301.543 82.7193C301.646 82.7193 302.066 82.7193 302.928 82.7193C303.789 82.7193 304.107 82.4116 304.159 82.2578",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1399 79.7239C74.7782 84.7039 80.3677 85.7068 83.6199 86.075C84.0188 86.075 85.332 85.9093 87.3938 85.2466C90.7073 84.1815 91.2596 80.3682 91.2596 79.0796C91.2596 75.7661 89.0506 74.8456 89.3267 71.6241C89.4214 70.5196 89.7869 69.323 89.3267 66.6538C89.1163 65.4334 87.4858 62.972 84.2643 62.5118C79.7542 61.8675 75.704 63.9845 76.5327 69.415C77.3399 74.705 73.6798 76.1342 74.1399 79.7239Z",
  fill: "#C2C7D0",
  stroke: "#C2C7D0"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M83.6208 68.6785V92.6098H83.0685L82.9137 68.6991L83.3482 66.7441L83.6208 68.6785Z",
  fill: "#A3A9B9",
  stroke: "#A3A9B9"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7133 72.7286C84.1736 72.6058 85.2229 72.2499 85.7383 71.8081C86.2537 71.3663 86.8121 70.8263 87.0269 70.6116",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M85.3686 71.9925C85.3073 71.6857 85.2214 71.0168 85.3686 70.7959C85.5159 70.575 85.6754 70.2743 85.7368 70.1516",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M82.7021 69.3233C82.334 69.2006 81.5056 68.8999 81.1374 68.679C80.7692 68.4581 80.1249 67.8506 79.8488 67.5745",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M81.504 68.8628C81.504 68.556 81.4672 67.9056 81.3199 67.7583",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7133 80.1843C84.4804 80.2764 86.1065 80.4052 86.4747 80.1843C86.8428 79.9634 87.303 79.6628 87.4871 79.54",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M85.5527 80.1841C85.6754 79.8159 85.9576 79.0612 86.1049 78.9876C86.2522 78.9139 86.5958 78.7728 86.7492 78.7114",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6983 76.4104C82.0847 76.3491 80.747 76.1895 80.3052 76.0423C79.8634 75.895 78.7711 75.1218 78.2802 74.7537",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1231 75.8582C80.0924 75.5514 79.9758 74.8825 79.7549 74.6616",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M81.4118 76.3181C81.197 76.5636 80.6754 76.9992 80.3073 77.1465",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M82.8841 82.3011C82.2091 82.2704 80.7303 82.1722 79.8467 82.0249C78.9631 81.8777 77.9444 81.1659 77.5456 80.8284",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M81.0437 82.117C81.0437 81.8408 80.9516 81.307 80.5834 81.0125",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M77.1774 82.0252C77.2387 82.0252 77.4903 82.0252 78.0058 82.0252C78.5212 82.0252 78.7114 81.8411 78.7421 81.749",
  stroke: "#A3A9B9",
  strokeLinecap: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 116.72,
  y: 0.5,
  width: 131.6,
  height: 88.7,
  rx: 3.5,
  fill: "white",
  stroke: "#00004B"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M123.539 11.0203C123.539 8.97681 125.195 7.32026 127.239 7.32026H235.459C237.502 7.32026 239.159 8.97681 239.159 11.0203V78.6803C239.159 80.7237 237.502 82.3803 235.459 82.3803H127.239C125.195 82.3803 123.539 80.7237 123.539 78.6803V35.5858V11.0203Z",
  fill: "#EFF1F5",
  stroke: "#00004B",
  strokeWidth: 0.6
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 119.34,
  y: 37.3491,
  width: 1.56,
  height: 15.47,
  rx: 0.78,
  fill: "#E8EAED"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48 45.216C246.48 46.4976 245.432 47.5365 244.14 47.5365C242.847 47.5365 241.8 46.4976 241.8 45.216C241.8 43.9345 242.847 42.8955 244.14 42.8955C245.432 42.8955 246.48 43.9345 246.48 45.216Z",
  fill: "#E8EAED"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M123.67 11.4515C123.647 9.22629 125.445 7.41016 127.67 7.41016H234.985C237.194 7.41016 238.985 9.20102 238.985 11.4102V15.6002H123.713L123.67 11.4515Z",
  fill: "#FEFEFE"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M126.36 20.72C126.36 19.6154 127.255 18.72 128.36 18.72H234.34C235.444 18.72 236.34 19.6154 236.34 20.72V76.78C236.34 77.8845 235.444 78.78 234.34 78.78H128.36C127.255 78.78 126.36 77.8845 126.36 76.78V20.72Z",
  fill: "white"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 153.659,
  y: 22.6201,
  width: 32.76,
  height: 3.12,
  rx: 1.56,
  fill: "#E8EAED"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 130.258,
  y: 22.6201,
  width: 21.84,
  height: 3.12,
  rx: 1.56,
  fill: "#E8EAED"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 223.86,
  y: 24.1802,
  width: 8.58,
  height: 3.12,
  rx: 1.56,
  fill: "#E8EAED"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 130.758,
  y: 28.5798,
  width: 31.76,
  height: 20.84,
  rx: 0.5,
  stroke: "#DFE2E7",
  strokeDasharray: "2.5 2.5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 126.36,
  y: 9.35986,
  width: 7.02,
  height: 4.68,
  fill: "#73DC78"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 130.758,
  y: 52.7598,
  width: 31.76,
  height: 20.84,
  rx: 0.5,
  stroke: "#DFE2E7",
  strokeDasharray: "2.5 2.5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 165.859,
  y: 28.5798,
  width: 30.98,
  height: 20.84,
  rx: 0.5,
  stroke: "#DFE2E7",
  strokeDasharray: "2.5 2.5"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 165.859,
  y: 52.7598,
  width: 30.98,
  height: 20.84,
  rx: 0.5,
  stroke: "#DFE2E7",
  strokeDasharray: "2.5 2.5"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 200.18,
  y: 28.5798,
  width: 31.76,
  height: 20.84,
  rx: 0.5,
  stroke: "#DFE2E7",
  strokeDasharray: "2.5 2.5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 200.18,
  y: 52.7598,
  width: 31.76,
  height: 20.84,
  rx: 0.5,
  stroke: "#DFE2E7",
  strokeDasharray: "2.5 2.5"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M190.738 79.1873C192.577 80.4813 192.78 81.8236 192.978 82.3221L194.648 88.8945C194.769 89.2204 194.829 89.562 195.386 91.7528C195.905 93.797 192.674 94.9602 191.571 93.2657C190.469 91.5712 191.252 90.244 190.737 87.2817C190.203 84.2071 188.057 82.9967 187.701 80.947C187.314 78.7199 190.104 78.7411 190.738 79.1873Z",
  fill: "#E8EAED",
  stroke: "#00004B"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M196.053 81.788C195.51 81.7063 193.245 82.5106 192.013 82.8421L193.282 89.1323C194.708 89.2364 196.543 88.7414 197.24 88.6203C197.923 88.5016 198.629 87.4991 198.169 86.8752C197.877 86.4807 197.188 85.2859 197.552 84.3428C198.003 83.1765 196.395 81.8397 196.053 81.788Z",
  fill: "#E8EAED",
  stroke: "#00004B"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M192.971 85.315C192.85 84.6182 192.682 83.3123 192.697 82.7232C192.335 82.6687 191.785 82.7409 191.672 82.9013C191.531 83.1018 191.687 85.0104 191.805 85.6936C191.924 86.3768 192.8 89.392 193.142 89.3326C193.415 89.2851 193.959 89.3079 194.167 89.1545C193.647 88.189 193.149 86.3398 192.971 85.315Z",
  fill: "#00004B",
  stroke: "#00004B"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M175.336 47.3493C175.835 47.2001 177.405 46.1782 177.229 45.6785C177.054 45.1789 175.982 46.0516 175.733 46.1262C175.484 46.2008 175.543 44.8025 175.954 44.4035C176.366 44.0044 177.584 43.9378 177.658 43.3636C177.732 42.7893 176.236 43.2371 175.656 43.5485C175.076 43.86 174.275 43.9395 173.864 44.3385C173.453 44.7376 173.049 45.5487 172.638 45.9477C172.309 46.2669 171.733 46.7708 171.405 47.1449L170.994 47.544L172.68 48.42L172.704 48.4324C172.708 48.4714 172.67 48.5704 172.849 48.5075C173.583 47.4596 174.837 47.4986 175.336 47.3493Z",
  fill: "white"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M172.68 48.42C172.753 48.3947 172.614 48.5899 172.849 48.5075M172.849 48.5075C173.583 47.4596 174.837 47.4986 175.336 47.3493C175.835 47.2001 177.405 46.1782 177.229 45.6785C177.054 45.1789 175.982 46.0516 175.733 46.1262C175.484 46.2008 175.543 44.8025 175.954 44.4035C176.366 44.0044 177.584 43.9378 177.658 43.3636C177.732 42.7893 176.236 43.2371 175.656 43.5485C175.076 43.86 174.275 43.9395 173.864 44.3385C173.453 44.7376 173.049 45.5487 172.638 45.9477C172.309 46.2669 171.733 46.7708 171.405 47.1449L170.994 47.544L172.849 48.5075Z",
  stroke: "#00004B"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M183.237 51.7147C183.086 52.0059 183.363 53.7774 183.615 54.6267C182.102 54.6267 178.615 54.7835 178.886 54.2627C179.075 53.8987 179.454 52.6247 179.643 51.7147L179.075 49.1666C178.697 49.3486 178.863 49.2816 178.409 48.8448C178.219 48.6628 177.829 47.8925 178.019 47.3466C178.191 46.8486 178.823 47.1647 179.075 47.3467H179.643C181.345 47.4073 184.826 47.4923 185.129 47.3467C185.507 47.1647 186.008 47.3579 185.818 48.4499C185.719 49.0244 185.192 49.4094 184.751 49.3487C184.246 50.016 183.388 51.4235 183.237 51.7147Z",
  fill: "white",
  stroke: "#00004B"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M194.399 67.7305C194.399 69.041 193.582 74.3974 192.412 77.1853L190.072 75.5922C190.135 75.2889 190.376 73.9311 190.462 73.6008C190.876 72.0077 190.876 70.5623 190.852 68.6406C190.849 68.3975 190.048 67.5485 189.67 67.1845C189.292 66.8205 187.921 64.8044 187.732 64.4404C187.543 64.0764 187.211 63.7265 187.211 63.9085V68.6406C187.211 69.3686 186.895 72.8873 186.832 74.8286H174.158C174.095 74.04 174.006 72.3898 174.158 72.0986C174.347 71.7346 174.158 66.8205 174.158 66.2745C174.158 65.7285 174.536 59.7225 174.536 59.1765C174.536 58.2665 174.082 58.4662 172.132 58.4662C170.182 58.4662 166.85 58.6483 166.282 58.4663C165.525 58.2236 164.58 58.2843 164.58 57.0102C164.58 56.1002 170.169 47.7126 170.572 47.7126C170.962 47.7126 171.375 48.111 172.132 48.111C172.738 48.111 172.66 48.3879 172.912 48.5092C172.132 50.1023 169.195 54.0982 169.498 54.0982C169.877 54.0982 172.936 54.3313 174.472 54.0851C175.578 53.9078 176.617 53.8984 177.184 53.8984C177.752 53.8984 180.211 54.2624 180.779 54.2624C181.346 54.2624 183.244 54.3672 183.806 54.4444C185.13 54.6264 186.076 54.2624 187.778 55.9004C188.635 56.7245 190.805 60.0865 191.183 60.8145C191.562 61.5425 194.399 66.0925 194.399 67.7305Z",
  fill: "#E8EAED",
  stroke: "#00004B"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M188.157 104.859C187.862 106.562 187.401 109.591 187.212 111.229L183.05 111.047V110.319C183.239 105.951 183.655 96.9237 183.806 95.7589C183.996 94.3029 182.861 91.2088 182.482 90.1168C182.104 89.0248 180.969 81.9267 180.401 82.6547C180.114 83.0231 179.455 89.3888 179.077 92.4828C178.951 95.1522 178.661 100.891 178.51 102.493C178.358 104.095 178.068 108.863 177.942 111.047H174.159V110.319C174.032 105.466 173.78 95.5769 173.78 94.8489V81.7447V70.6426C173.78 70.3514 173.969 65.7286 174.159 63.1805C174.185 62.8175 174.726 62.0885 175.672 61.1785C176.223 60.6479 176.177 59.7205 176.239 58.8125C176.429 56.0825 176.429 55.7185 176.618 54.0804C176.618 54.0804 176.807 53.8984 177.375 53.8984C177.973 53.8984 178.131 54.0804 178.131 54.0804C177.942 56.4465 177.564 60.8145 177.942 60.9965C178.805 61.4115 181.726 61.1785 183.239 61.1785C184.752 61.1785 184.563 60.4505 184.563 59.9045C184.563 59.4677 184.374 56.0218 184.374 54.4444C184.563 54.4444 185.131 54.4444 185.698 54.6264C185.95 56.9925 186.324 60.7856 186.455 61.5425C186.644 62.6345 187.212 62.6345 187.212 63.9085V67.7306C187.212 69.7326 186.833 72.8266 187.022 74.6467C187.212 76.4667 187.968 81.3807 188.347 82.6547C188.725 83.9288 190.049 95.0309 190.049 96.1229C190.049 97.2149 188.536 102.675 188.157 104.859Z",
  fill: "#00004B",
  stroke: "#00004B"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M188.206 110.719C188.309 109.647 188.414 108.502 188.519 107.499C188.582 106.902 188.116 106.377 187.515 106.377H183.594C183.012 106.377 182.553 106.872 182.602 107.453C182.8 109.783 183.156 113.672 183.156 113.928V116.382H184.474L184.902 115.519L185.791 116.382H192.817C192.89 116.257 192.992 115.601 192.817 115.148C192.597 114.582 188.645 113.928 188.206 113.551C187.767 113.173 188.101 111.809 188.206 110.719Z",
  fill: "white",
  stroke: "#00004B"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 7.42857,
  height: 0.71469,
  transform: "matrix(-1 0 0 1 192.914 115.668)",
  fill: "#00004B"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M178.365 115.42C178.365 115.151 178.365 110.507 178.654 107.541C178.714 106.928 178.24 106.377 177.625 106.377H174.682C174.098 106.377 173.639 106.875 173.69 107.456C173.839 109.156 174.032 111.193 174.032 111.957C174.032 112.919 174.032 115.613 174.249 116.382H178.365V115.42Z",
  fill: "white",
  stroke: "#00004B"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M188.903 77.1859C189.127 76.7289 189.599 75.9177 189.935 75.8256L192.413 77.1858C192.424 77.3973 192.539 78.7212 192.339 79.0845C191.633 80.3721 190.073 79.9738 189.683 79.5755C189.393 79.2791 188.513 77.9824 188.903 77.1859Z",
  fill: "white",
  stroke: "#00004B"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 3.71429,
  height: 0.71469,
  transform: "matrix(-1 0 0 1 178.057 115.668)",
  fill: "#00004B"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 1.48571,
  height: 0.71469,
  transform: "matrix(-1 0 0 1 184.742 115.668)",
  fill: "#00004B"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M184.752 49.3482C185.055 48.9114 185.698 48.6201 185.509 47.3462L186.076 46.4361C186.202 46.1935 186.644 45.8901 186.266 45.1622C186.027 44.7018 185.887 44.2522 186.076 44.0702C186.265 43.8882 186.408 43.6391 186.076 43.1602C185.698 42.6142 184.941 43.1602 184.563 42.6142C184.354 42.3112 184.345 41.8768 183.806 41.7042C183.239 41.5222 182.918 41.9389 182.562 41.9389C181.967 41.9388 181.835 41.3401 181.158 41.3401C180.779 41.3401 180.432 41.8861 179.834 41.8861C178.699 41.8861 178.699 42.6141 178.699 42.9781C178.699 43.3421 177.936 43.3639 177.753 44.0701C177.563 44.7981 178.688 45.6652 178.373 46.1193C177.994 46.6653 178.699 48.2562 178.888 48.9842C179.286 50.5186 180.212 51.5322 180.969 51.7142C181.726 51.8962 183.05 51.8962 183.806 50.8042C184.041 50.4656 184.374 49.8942 184.752 49.3482Z",
  fill: "#00004B",
  stroke: "#00004B"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.d0482255840176452ce6cf5f56fe63a6.svg";